<template>
  <div @click="handleClick" class="btn --blue">
    <i class="far fa-edit"></i>
  </div>
</template>

<script>
import BookingModal from '../Modal/BookingForm';
import ModalMixins from '../../../mixins/modal-mixins';
import BookingMixins from '../../../mixins/booking-mixins';

export default {
  mixins: [ModalMixins, BookingMixins],

  props: {
    id: Number,
  },

  methods: {
    handleClick() {
      this.showModal(BookingModal, {
        id: this.id,
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Booking/ActionButtons/Edit.vue